export const DATADOG_EVENTS = {
  added: 'dashboard.auth.token.added',
  error: 'dashboard.auth.error',
  expired: 'dashboard.auth.token.expired',
  newProvider: 'dashboard.auth.new.provider',
  oldProvider: 'dashboard.auth.old.provider',
  removed: 'dashboard.auth.token.removed',
  renewed: 'dashboard.auth.token.renewed',
  setStorage: 'dashboard.auth.token.set.storage',
} as const;
